/* eslint-disable @typescript-eslint/no-explicit-any */
// Personal libs
import { UpdateServiceNameEnum } from './update-service-enum'
import { useUpdateManagerStore } from '@stores/updateManager'
import { logger } from '@shared/lib/logger/logger-manager'

/**
 * An UpdateService is a service which updates data in stores from API
 */
export abstract class UpdateService {
  /**
   * Update manager store of update service
   */
  private updateManagerStore = useUpdateManagerStore()

  abstract updateServiceName: UpdateServiceNameEnum

  protected canRunInParallel = false

  /**
   * Listens update service
   */
  abstract task(params?: any): Promise<any>

  /**
   * Returns result of update service
   *
   * @returns {Promise<any>}
   */
  public async exec<T = any, S = any>(params?: S): Promise<T | undefined> {
    if (this.canRunInParallel) {
      return await this.task(params)
    } else {
      if (!this.keyExists(this.updateServiceName)) {
        this.updateManagerStore.workInProgress?.push({
          [this.updateServiceName]: false
        })
      }

      if (!this.updateManagerStore.workInProgress[this.updateServiceName]) {
        this.updateManagerStore.workInProgress[this.updateServiceName] = true
        const result = await this.task(params)
        this.updateManagerStore.workInProgress[this.updateServiceName] = false

        return result
      } else {
        logger?.warn(`[UpdateManager] - service '${this.updateServiceName}' already in progress`)
      }
    }
  }

  /**
   * Set canRunInParallel
   * @param value
   * @returns
   */
  public setCanRunInParallel(value?: boolean) {
    this.canRunInParallel = value === true

    return this
  }

  /**
   * Keys exists
   * @param {UpdateServiceNameEnum} k
   * @returns {boolean} true if exists
   */
  private keyExists(k: UpdateServiceNameEnum): boolean {
    return this.updateManagerStore.workInProgress && this.updateManagerStore.workInProgress.length > 0 && Object.keys(this.updateManagerStore.workInProgress).includes(k)
  }
}
